import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDialog = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.999 5H14C14.5128 5 14.9355 5.38604 14.9933 5.88338L15 6V15L13 13H6C5.48716 13 5.06449 12.614 5.00673 12.1166L5 12V11H12C12.5128 11 12.9355 10.614 12.9933 10.1166L13 10L12.999 5H14H12.999ZM10 1C10.5523 1 11 1.44772 11 2V8C11 8.55228 10.5523 9 10 9H3L1 11V2C1 1.44772 1.44772 1 2 1H10Z",
		fill: "#545e6b"
	})]
});
const ForwardRef = forwardRef(SvgDialog);
export { ForwardRef as ReactComponent };
